import { observer } from "mobx-react";
import studioStore from '@/stores/studioStore';
import Products from '@/components/products/Products';

const FeaturedProducts = observer(({
  sectionTitle,
  backgroundColor,
  products,
  crossSellProducts,
  ad,
}) => {
  return (
    <div className="section-featured-products py-0 md:py-8" style={{backgroundColor: backgroundColor}}>
      <div className="2xl:container mx-auto px-2 2xl:px-0">
        <h2 className="text-center pb-2 md:pb-8 pt-4 md:pt-3 text-4xl font-secondary" style={{color: studioStore?.settings?.colors?.primary_color}}>
          {sectionTitle}
        </h2>
        <div className="flex min-h-screen flex-col items-center justify-between">
          <Products products={products} crossSellProducts={crossSellProducts} ad={ad} />
        </div>
      </div>
    </div>
  )
});

export default FeaturedProducts